var map = {
	"./site-logo-desktop-footer.svg": 72055,
	"./site-logo-desktop.svg": 43713,
	"./site-logo-drawer-mobile.svg": 66211,
	"./site-logo-drawer.svg": 94400,
	"./site-logo-mobile-drawer.svg": 91181,
	"./site-logo-mobile.svg": 17589,
	"./site-logo-sm.svg": 15591,
	"./site-logo-tv.svg": 18765,
	"./site-logo-wrapper-mobile-scrolled.svg": 72552,
	"./site-logo-wrapper-mobile.svg": 68807,
	"./site-logo-wrapper-scrolled.svg": 48017,
	"./site-logo-wrapper.svg": 148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93680;